var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading,
            expression: "loading"
          }
        ]
      },
      [
        _c("loading-spinner", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loading,
              expression: "loading"
            }
          ]
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.loading,
            expression: "!loading"
          }
        ]
      },
      [
        _c(
          "b-container",
          [
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { cols: "2", align: "right" } }, [
                  _c("label", { attrs: { for: "alternativePaymentName" } }, [
                    _vm._v("Name:")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "10" } },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "alternativePaymentName",
                        size: "sm",
                        type: "text"
                      },
                      model: {
                        value: _vm.alternativePayment.name,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.alternativePayment,
                            "name",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "alternativePayment.name"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { cols: "2", align: "right" } }, [
                  _c(
                    "label",
                    { attrs: { for: "alternativePaymentProdIdAlias" } },
                    [_vm._v("Product ID Alias:")]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "10" } },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "alternativePaymentProdIdAlias",
                        size: "sm",
                        type: "text"
                      },
                      model: {
                        value: _vm.alternativePayment.prodAliasId,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.alternativePayment,
                            "prodAliasId",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "alternativePayment.prodAliasId"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { cols: "2", align: "right" } }, [
                  _c(
                    "label",
                    { attrs: { for: "alternativePaymentWSGAccess" } },
                    [_vm._v("WSG Access:")]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "10" } },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "alternativePaymentWSGAccess",
                        size: "sm",
                        type: "text"
                      },
                      model: {
                        value: _vm.alternativePayment.wsgAccess,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.alternativePayment,
                            "wsgAccess",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "alternativePayment.wsgAccess"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { cols: "2", align: "right" } }, [
                  _c("label", { attrs: { for: "alternativePaymentWSGURL" } }, [
                    _vm._v("WSG URL:")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "10" } },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "alternativePaymentWSGURL",
                        size: "sm",
                        type: "text"
                      },
                      model: {
                        value: _vm.alternativePayment.wsgUrl,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.alternativePayment,
                            "wsgUrl",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "alternativePayment.wsgUrl"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { cols: "2", align: "right" } }, [
                  _c("label", { attrs: { for: "alternativePaymentWSGUser" } }, [
                    _vm._v("WSG User:")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "10" } },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "alternativePaymentWSGUser",
                        size: "sm",
                        type: "text"
                      },
                      model: {
                        value: _vm.alternativePayment.wsgUser,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.alternativePayment,
                            "wsgUser",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "alternativePayment.wsgUser"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "b-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isApplePayment,
                    expression: "isApplePayment"
                  }
                ]
              },
              [
                _c("b-col", { attrs: { cols: "12" } }, [
                  _c("h5", [_vm._v("Apple Pay Settings")])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isApplePayment,
                    expression: "isApplePayment"
                  }
                ]
              },
              [
                _c("b-col", { attrs: { cols: "2", align: "right" } }, [
                  _c(
                    "label",
                    { attrs: { for: "alternativePaymentMerchantId" } },
                    [_vm._v("Merchant ID:")]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "10" } },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "alternativePaymentMerchantId",
                        size: "sm",
                        type: "text"
                      },
                      model: {
                        value: _vm.alternativePayment.merchantId,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.alternativePayment,
                            "merchantId",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "alternativePayment.merchantId"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isApplePayment,
                    expression: "isApplePayment"
                  }
                ]
              },
              [
                _c("b-col", { attrs: { cols: "2", align: "right" } }, [
                  _c(
                    "label",
                    { attrs: { for: "alternativePaymentInitiativeContext" } },
                    [_vm._v("Initiative Context:")]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "10" } },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "alternativePaymentInitiativeContext",
                        size: "sm",
                        type: "text"
                      },
                      model: {
                        value: _vm.alternativePayment.initiativeContext,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.alternativePayment,
                            "initiativeContext",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "alternativePayment.initiativeContext"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isApplePayment,
                    expression: "isApplePayment"
                  }
                ]
              },
              [
                _c("b-col", { attrs: { cols: "2", align: "right" } }, [
                  _c(
                    "label",
                    { attrs: { for: "alternativePaymentSellerName" } },
                    [_vm._v("Seller Name:")]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "10" } },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "alternativePaymentSellerName",
                        size: "sm",
                        type: "text"
                      },
                      model: {
                        value: _vm.alternativePayment.sellerName,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.alternativePayment,
                            "sellerName",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "alternativePayment.sellerName"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isApplePayment,
                    expression: "isApplePayment"
                  }
                ]
              },
              [
                _c("b-col", { attrs: { cols: "2" } }),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "10" } },
                  [
                    _c(
                      "b-form-checkbox",
                      {
                        attrs: {
                          id: "alternativePaymentShowAmount",
                          size: "sm",
                          plain: ""
                        },
                        model: {
                          value: _vm.alternativePayment.showAmount,
                          callback: function($$v) {
                            _vm.$set(_vm.alternativePayment, "showAmount", $$v)
                          },
                          expression: "alternativePayment.showAmount"
                        }
                      },
                      [_vm._v("\n            Show amount\n          ")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isAmazonPayment,
                    expression: "isAmazonPayment"
                  }
                ]
              },
              [
                _c("b-col", { attrs: { cols: "12" } }, [
                  _c("h5", [_vm._v("Amazon Pay Settings")])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isAmazonPayment,
                    expression: "isAmazonPayment"
                  }
                ]
              },
              [
                _c("b-col", { attrs: { cols: "2", align: "right" } }, [
                  _c(
                    "label",
                    { attrs: { for: "alternativePaymentAuthToken" } },
                    [_vm._v("Auth Token:")]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "10" } },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "alternativePaymentAuthToken",
                        size: "sm",
                        type: "text"
                      },
                      model: {
                        value: _vm.alternativePayment.authToken,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.alternativePayment,
                            "authToken",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "alternativePayment.authToken"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isAmazonPayment,
                    expression: "isAmazonPayment"
                  }
                ]
              },
              [
                _c("b-col", { attrs: { cols: "2", align: "right" } }, [
                  _c("label", { attrs: { for: "alternativePaymentKeyId" } }, [
                    _vm._v("Key ID:")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "10" } },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "alternativePaymentKeyId",
                        size: "sm",
                        type: "text"
                      },
                      model: {
                        value: _vm.alternativePayment.keyId,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.alternativePayment,
                            "keyId",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "alternativePayment.keyId"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isAmazonPayment,
                    expression: "isAmazonPayment"
                  }
                ]
              },
              [
                _c("b-col", { attrs: { cols: "2", align: "right" } }, [
                  _c(
                    "label",
                    { attrs: { for: "alternativePaymentMerchantId" } },
                    [_vm._v("Merchant ID:")]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "10" } },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "alternativePaymentMerchantId",
                        size: "sm",
                        type: "text"
                      },
                      model: {
                        value: _vm.alternativePayment.merchantId,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.alternativePayment,
                            "merchantId",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "alternativePayment.merchantId"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isAmazonPayment,
                    expression: "isAmazonPayment"
                  }
                ]
              },
              [
                _c("b-col", { attrs: { cols: "2", align: "right" } }, [
                  _c(
                    "label",
                    { attrs: { for: "alternativePaymentSecretKey" } },
                    [_vm._v("Secret Key:")]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "10" } },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "alternativePaymentSecretKey",
                        size: "sm",
                        type: "text"
                      },
                      model: {
                        value: _vm.alternativePayment.secretKey,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.alternativePayment,
                            "secretKey",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "alternativePayment.secretKey"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isAmazonPayment,
                    expression: "isAmazonPayment"
                  }
                ]
              },
              [
                _c("b-col", { attrs: { cols: "2", align: "right" } }, [
                  _c(
                    "label",
                    { attrs: { for: "alternativePaymentMWSAuthToken" } },
                    [_vm._v("MWS Auth Token:")]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "10" } },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "alternativePaymentMWSAuthToken",
                        size: "sm",
                        type: "text"
                      },
                      model: {
                        value: _vm.alternativePayment.mwsAuthToken,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.alternativePayment,
                            "mwsAuthToken",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "alternativePayment.mwsAuthToken"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isAmazonPayment,
                    expression: "isAmazonPayment"
                  }
                ]
              },
              [
                _c("b-col", { attrs: { cols: "2", align: "right" } }, [
                  _c(
                    "label",
                    { attrs: { for: "alternativePaymentClientId" } },
                    [_vm._v("Client ID:")]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "10" } },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "alternativePaymentClientId",
                        size: "sm",
                        type: "text"
                      },
                      model: {
                        value: _vm.alternativePayment.amazonClientId,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.alternativePayment,
                            "amazonClientId",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "alternativePayment.amazonClientId"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isAmazonPayment,
                    expression: "isAmazonPayment"
                  }
                ]
              },
              [
                _c("b-col", { attrs: { cols: "2", align: "right" } }, [
                  _c(
                    "label",
                    { attrs: { for: "alternativePaymentPlatformId" } },
                    [_vm._v("Platform ID:")]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "10" } },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "alternativePaymentPlatformId",
                        size: "sm",
                        type: "text"
                      },
                      model: {
                        value: _vm.alternativePayment.platformId,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.alternativePayment,
                            "platformId",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "alternativePayment.platformId"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isAmazonPayment,
                    expression: "isAmazonPayment"
                  }
                ]
              },
              [
                _c("b-col", { attrs: { cols: "2", align: "right" } }, [
                  _c(
                    "label",
                    { attrs: { for: "alternativePaymentStoreName" } },
                    [_vm._v("Store Name:")]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "10" } },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "alternativePaymentStoreName",
                        size: "sm",
                        type: "text"
                      },
                      model: {
                        value: _vm.alternativePayment.storeName,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.alternativePayment,
                            "storeName",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "alternativePayment.storeName"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isAmazonPayment,
                    expression: "isAmazonPayment"
                  }
                ]
              },
              [
                _c("b-col", { attrs: { cols: "2", align: "right" } }, [
                  _c(
                    "label",
                    { attrs: { for: "alternativePaymentSellerId" } },
                    [_vm._v("Seller ID:")]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "10" } },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "alternativePaymentSellerId",
                        size: "sm",
                        type: "text"
                      },
                      model: {
                        value: _vm.alternativePayment.sellerId,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.alternativePayment,
                            "sellerId",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "alternativePayment.sellerId"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isAmazonPayment,
                    expression: "isAmazonPayment"
                  }
                ]
              },
              [
                _c("b-col", { attrs: { cols: "2", align: "right" } }, [
                  _c(
                    "label",
                    { attrs: { for: "alternativePaymentEnvironment" } },
                    [_vm._v("Environment:")]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "10" } },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "alternativePaymentEnvironment",
                        size: "sm",
                        type: "text"
                      },
                      model: {
                        value: _vm.alternativePayment.environment,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.alternativePayment,
                            "environment",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "alternativePayment.environment"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isPayPalPayment,
                    expression: "isPayPalPayment"
                  }
                ]
              },
              [
                _c("b-col", { attrs: { cols: "12" } }, [
                  _c("h5", [_vm._v("PayPal Settings")])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isPayPalPayment,
                    expression: "isPayPalPayment"
                  }
                ]
              },
              [
                _c("b-col", { attrs: { cols: "2", align: "right" } }, [
                  _c(
                    "label",
                    { attrs: { for: "alternativePaymentMerchantId" } },
                    [_vm._v("Merchant ID:")]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "10" } },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "alternativePaymentMerchantId",
                        size: "sm",
                        type: "text"
                      },
                      model: {
                        value: _vm.alternativePayment.merchantId,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.alternativePayment,
                            "merchantId",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "alternativePayment.merchantId"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isPayPalPayment,
                    expression: "isPayPalPayment"
                  }
                ]
              },
              [
                _c("b-col", { attrs: { cols: "2", align: "right" } }, [
                  _c("label", { attrs: { for: "alternativePaymentKeyId" } }, [
                    _vm._v("Key ID:")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "10" } },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "alternativePaymentKeyId",
                        size: "sm",
                        type: "text"
                      },
                      model: {
                        value: _vm.alternativePayment.keyId,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.alternativePayment,
                            "keyId",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "alternativePayment.keyId"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isPayPalPayment,
                    expression: "isPayPalPayment"
                  }
                ]
              },
              [
                _c("b-col", { attrs: { cols: "2", align: "right" } }, [
                  _c(
                    "label",
                    { attrs: { for: "alternativePaymentSecretKey" } },
                    [_vm._v("Secret Key:")]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "10" } },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "alternativePaymentSecretKey",
                        size: "sm",
                        type: "text"
                      },
                      model: {
                        value: _vm.alternativePayment.secretKey,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.alternativePayment,
                            "secretKey",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "alternativePayment.secretKey"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isPayPalPayment,
                    expression: "isPayPalPayment"
                  }
                ]
              },
              [
                _c("b-col", { attrs: { cols: "2", align: "right" } }, [
                  _c(
                    "label",
                    { attrs: { for: "alternativePaymentPaymentURL" } },
                    [_vm._v("Payment URL:")]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "10" } },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "alternativePaymentPaymentURL",
                        size: "sm",
                        type: "text"
                      },
                      model: {
                        value: _vm.alternativePayment.paymentUrl,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.alternativePayment,
                            "paymentUrl",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "alternativePayment.paymentUrl"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isPayPalPayment,
                    expression: "isPayPalPayment"
                  }
                ]
              },
              [
                _c("b-col", { attrs: { cols: "2", align: "right" } }, [
                  _c(
                    "label",
                    { attrs: { for: "alternativePaymentReturnURL" } },
                    [_vm._v("Return URL:")]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "10" } },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "alternativePaymentReturnURL",
                        size: "sm",
                        type: "text"
                      },
                      model: {
                        value: _vm.alternativePayment.returnUrl,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.alternativePayment,
                            "returnUrl",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "alternativePayment.returnUrl"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isPayPalPayment,
                    expression: "isPayPalPayment"
                  }
                ]
              },
              [
                _c("b-col", { attrs: { cols: "2", align: "right" } }, [
                  _c(
                    "label",
                    { attrs: { for: "alternativePaymentCancelURL" } },
                    [_vm._v("Cancel URL:")]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "10" } },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "alternativePaymentCancelURL",
                        size: "sm",
                        type: "text"
                      },
                      model: {
                        value: _vm.alternativePayment.cancelUrl,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.alternativePayment,
                            "cancelUrl",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "alternativePayment.cancelUrl"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { cols: "2" } }),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "10" } },
                  [
                    _c(
                      "b-form-checkbox",
                      {
                        attrs: {
                          id: "alternativePaymentAddressSuppressed",
                          size: "sm",
                          plain: ""
                        },
                        model: {
                          value: _vm.alternativePayment.addressSuppressed,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.alternativePayment,
                              "addressSuppressed",
                              $$v
                            )
                          },
                          expression: "alternativePayment.addressSuppressed"
                        }
                      },
                      [
                        _vm._v(
                          "\n            Suppress shipping address\n          "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isPayPalPayment,
                    expression: "isPayPalPayment"
                  }
                ]
              },
              [
                _c("b-col", { attrs: { cols: "2" } }),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "10" } },
                  [
                    _c(
                      "b-form-checkbox",
                      {
                        attrs: {
                          id: "alternativePaymentVenmo",
                          size: "sm",
                          plain: ""
                        },
                        model: {
                          value: _vm.alternativePayment.venmo,
                          callback: function($$v) {
                            _vm.$set(_vm.alternativePayment, "venmo", $$v)
                          },
                          expression: "alternativePayment.venmo"
                        }
                      },
                      [
                        _vm._v(
                          "\n            Suppress Venmo Button\n          "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isPayPalPayment,
                    expression: "isPayPalPayment"
                  }
                ]
              },
              [
                _c("b-col", { attrs: { cols: "2" } }),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "10" } },
                  [
                    _c(
                      "b-form-checkbox",
                      {
                        attrs: {
                          id: "alternativePaymentPayLater",
                          size: "sm",
                          plain: ""
                        },
                        model: {
                          value: _vm.alternativePayment.payLater,
                          callback: function($$v) {
                            _vm.$set(_vm.alternativePayment, "payLater", $$v)
                          },
                          expression: "alternativePayment.payLater"
                        }
                      },
                      [
                        _vm._v(
                          "\n            Suppress PayLater Button\n          "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isPayPalPayment,
                    expression: "isPayPalPayment"
                  }
                ]
              },
              [
                _c("b-col", { attrs: { cols: "2" } }),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "10" } },
                  [
                    _c(
                      "b-form-checkbox",
                      {
                        attrs: {
                          id: "alternativePaymentCredit",
                          size: "sm",
                          plain: ""
                        },
                        model: {
                          value: _vm.alternativePayment.credit,
                          callback: function($$v) {
                            _vm.$set(_vm.alternativePayment, "credit", $$v)
                          },
                          expression: "alternativePayment.credit"
                        }
                      },
                      [
                        _vm._v(
                          "\n            Suppress Credit Button\n          "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "b-row",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isApplePayment,
                    expression: "!isApplePayment"
                  }
                ]
              },
              [
                _c("b-col", { attrs: { cols: "1" } }, [
                  _c("label", { attrs: { for: "altPay-Version" } }, [
                    _vm._v("Version:")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "2" } },
                  [
                    _c("b-form-select", {
                      attrs: {
                        id: "alternativePaymentVersion",
                        options: _vm.altPayVersion,
                        size: "sm",
                        plain: ""
                      },
                      model: {
                        value: _vm.alternativePayment.version,
                        callback: function($$v) {
                          _vm.$set(_vm.alternativePayment, "version", $$v)
                        },
                        expression: "alternativePayment.version"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "3" } },
                  [
                    _c(
                      "b-form-checkbox",
                      {
                        attrs: {
                          id: "alternativePaymentOnboardComplete",
                          size: "sm",
                          plain: ""
                        },
                        model: {
                          value: _vm.alternativePayment.onboardComplete,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.alternativePayment,
                              "onboardComplete",
                              $$v
                            )
                          },
                          expression: "alternativePayment.onboardComplete"
                        }
                      },
                      [_vm._v("\n            Onboarding Completed\n          ")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "10" } },
                  [
                    _c(
                      "b-alert",
                      {
                        attrs: {
                          color: _vm.success ? "success" : "danger",
                          variant: _vm.success ? "success" : "danger",
                          show: _vm.showMsg
                        }
                      },
                      [
                        _vm._v(
                          "\n            " + _vm._s(_vm.msg) + "\n          "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "2" } },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "primary" },
                        on: { click: _vm.saveData }
                      },
                      [_vm._v("\n            Save\n          ")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }